import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { createStartTourneyOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { selectShouldShowStartTourneyButton } from '../../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../../redux/store';
import { Button } from '../../pixiComponents/button';
export const StartTourneyButtonContainer = () => {
    const tableAreaDimensions = useAppSelector((state) => state.gameDimensions.tableAreaDimensions, shallowEqual);
    const shouldShowStartTourneyButton = useAppSelector(selectShouldShowStartTourneyButton);
    const socketSend = useSocketSend();
    const onClickStartTourney = useCallback(() => {
        socketSend(createStartTourneyOutbound());
    }, [socketSend]);
    if (!tableAreaDimensions) {
        return null;
    }
    if (!shouldShowStartTourneyButton) {
        return null;
    }
    return (_jsx(Button, { pixiObjectData: { type: 'start-tourney-button' }, onClick: onClickStartTourney, labelProperties: { label: 'START TOURNEY', bitmapTextStyleType: 'button-label' }, bounds: {
            x: Math.round(tableAreaDimensions.w / 2),
            y: Math.round(tableAreaDimensions.h / 2),
            w: Math.round(3 * (tableAreaDimensions.w / 5)),
            h: Math.round(tableAreaDimensions.h / 3)
        }, shrinkToFit: true }));
};
